<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="title + '员工安全职责承诺卡'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="w-full h-full relative z-9999">
        <el-table
          :data="equipDataList"
          class="w-full"
          :height="tableHeight"
          v-loading="equipTableLoading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="承诺人"
            prop="pledgee"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="岗位"
            prop="post"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属风险点"
            width="100"
            prop="belongRiskPointStr"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="主管领导"
            prop="supervisorLeadership"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="承诺时间" prop="commitmentTime" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.commitmentTime
                  ? dayjs(scope.row.commitmentTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="承诺类容"
            prop="commitmentContent"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <!-- <div slot="empty" class="w-full h-full flex justify-center items-center">
            <img src="../../../assets/images/no_data@1x.png" alt="" />
          </div> -->
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <CockpitDialog
      class="fixed top-200px left-500px w-900px h-600px !z-10000"
      v-if="detailVisible"
      :title="'查看员工安全职责承诺卡'"
      @close="detailVisible = false"
    >
      <div class="w-full h-full relative z-10000 overflow-y-auto">
        <div class="pdf-panel px-10px pt-20px" ref="card">
          <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
            安全职责承诺卡
          </div>
          <div class="table-form border-1 bg-white">
            <table class="table-body w-full">
              <tr class="border-b-1">
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary">
                    承诺人
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.pledgee }}</div>
                </td>

                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>岗位</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.post }}</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>主管领导</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.supervisorLeadership }}</div>
                </td>
              </tr>
              <tr class="border-b-1">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>承诺日期</div>
                </td>
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>
                    {{
                      formData.commitmentTime
                        ? dayjs(formData.commitmentTime).format('YYYY-MM-DD HH:mm:ss')
                        : undefined
                    }}
                  </div>
                </td>
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>关联区域</div>
                </td>
                <td colspan="4" class="w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary font-normal">
                    {{ formData.associateRiskAreasStr }}
                  </div>
                </td>
              </tr>
              <tr class="border-b-1">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>所属风险点</div>
                </td>
                <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary font-normal">
                    {{ formData.belongRiskPointStr }}
                  </div>
                </td>
              </tr>
              <tr class="border-b-1">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>承诺内容</div>
                </td>
                <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary font-normal">
                    {{ formData.commitmentContent }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { SecurityResponsibilityCommitmentCardApi } from '@wiz-api/double-prevention-management'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'

const securityResponsibilityCommitmentCardApi = new SecurityResponsibilityCommitmentCardApi()

export default {
  name: 'duty-card-list',
  components: {
    CockpitDialog,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: true,
      detailVisible: false,
      formData: {
        id: undefined,
        pledgeeId: undefined,
        pledgee: '',
        postId: undefined,
        post: '',
        belongRiskPoint: undefined,
        belongRiskPointStr: '',
        riskPointNumber: undefined,
        associateRiskAreas: undefined,
        associateRiskAreasStr: '',
        supervisorLeadershipId: undefined,
        supervisorLeadership: '',
        commitmentTime: undefined,
        commitmentContent: '',
        annex: undefined,
      },
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: this.areaId,
        evaluationLevel: '',
        riskPointType: 0,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 60px)'
    },
  },
  mounted() {
    this.getEquipList()
  },
  methods: {
    async handleView(row) {
      const [err, res] = await securityResponsibilityCommitmentCardApi.get(row.id)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
        this.detailVisible = true
      }
    },
    // 切换查询
    changeValues(values) {
      this.handleSearch()
    },
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const data = {
        associateRiskAreaId: this.areaId,
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await securityResponsibilityCommitmentCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/styles/filterSelect.scss';
</style>
<style scoped lang="scss">
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';
@import '../../../assets/styles/loading.scss';

::v-deep .round-button {
  line-height: 1;
}
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
// ::v-deep .el-table__empty-text {
//   display: block;
//   height: 100%;
//   width: 100%;
// }
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }
  ::v-deep .el-card .el-card__header {
    padding: 10px;
  }

  ::v-deep .custom-card {
    border-bottom: none !important;
  }

  ::v-deep .el-card .el-card__header {
    padding: 0 !important;
  }
}
</style>
